import { render, staticRenderFns } from "./WallScheduleBlockItemSettings.vue?vue&type=template&id=f0b4551c"
import script from "./WallScheduleBlockItemSettings.vue?vue&type=script&lang=js"
export * from "./WallScheduleBlockItemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports